var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFleetSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.904,
    viewBox: "0 0 16 15.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25556e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_build_24px",
    className: "cls-1",
    d: "M16.746,14.1,10.138,7.49A4.661,4.661,0,0,0,9.049,2.48a4.8,4.8,0,0,0-5.374-.944L6.8,4.658,4.619,6.837l-3.2-3.123a4.68,4.68,0,0,0,.944,5.374,4.661,4.661,0,0,0,5.011,1.089l6.608,6.608a.7.7,0,0,0,1.017,0l1.67-1.67A.654.654,0,0,0,16.746,14.1Z",
    transform: "translate(-0.956 -1.1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFleetSetting);
export default __webpack_public_path__ + "static/media/ic_fleet_setting.67b1752ccd46f2409639fc4e16408450.svg";
export { ForwardRef as ReactComponent };